import OrderViewerApiService from '../api/orderViewerApiService';
import { OrderDocumentOptions } from '../typing/enums';
import { IOrderViewerMainStore } from '../typing/stores';
import { OrderViewerColors } from '../utils/constants';
import { isOrderDrm } from '../utils/orderUtils';
import { createStyles, makeStyles } from '@mui/styles';
import { inject, observer } from 'mobx-react';
import { useEffect } from 'react';

const useStyles = makeStyles(() =>
	createStyles({
		root: {
			padding: '1rem 1.5rem 0.75rem 1.5rem',
			display: 'flex',
			gap: '1rem',
			flexDirection: 'column'
		},
		linkText: {
			fontWeight: 500,
			color: OrderViewerColors.success500,
			cursor: 'pointer'
		}
	})
);

export interface ILinkoutMessageProps {
	message?: string;
	isAutoLinksEnabled?: boolean;
	orderViewerApiService?: OrderViewerApiService;
	orderId?: number;
	options?: OrderDocumentOptions;
}

const LinkoutMessage: React.FunctionComponent<ILinkoutMessageProps> = props => {
	const classes = useStyles();
	let checked = false;

	const onCheckboxChecked = async () => {
		checked = !checked;
		if (checked) {
			await props.orderViewerApiService.changeAutoLinksEnabled(props.orderId, !props.isAutoLinksEnabled);
		}
	};

	const openDocument = () => {
		window.open(props.message, '_blank');
	};

	const text = props.isAutoLinksEnabled
		? localize(
				'Do not open online documents automatically in the future. I will open them by clicking on the link above.'
		  )
		: localize(
				'I have disabled my popup blocker for this website. Please automatically open my online documents in the future.'
		  );

	const useDrm: boolean = isOrderDrm(props.options);

	useEffect(() => {
		if (props.isAutoLinksEnabled && !useDrm) {
			openDocument();
		}
	}, []);

	return (
		<div className={classes.root}>
			<a className={classes.linkText} data-test-id="linkout-message-link" onClick={openDocument}>
				{props.message}
			</a>
			{useDrm === false && (
				<div className="rup-checkbox">
					<input id="auto-links-check" type="checkbox" onChange={onCheckboxChecked} />
					<label htmlFor="auto-links-check">{text}</label>
				</div>
			)}
		</div>
	);
};

export default inject((stores: IOrderViewerMainStore) => ({
	message: stores.orderViewerStore.viewModel.documentModel.message,
	isAutoLinksEnabled: stores.orderViewerStore.viewModel.documentModel.isAutoLinksEnabled,
	orderViewerApiService: stores.api.orderViewerApiService,
	orderId: stores.orderViewerStore.viewModel.orderId,
	options: stores.orderViewerStore.viewModel.documentModel.documentOptions
}))(observer(LinkoutMessage));
